// Xuất danh sách Hợp tác xã ra .xlsx (exceljs — không dùng skill xlsx Anthropic).

import ExcelJS from "exceljs";

const TEN_CONG_TY = "CÔNG TY TNHH LV NÔNG NGHIỆP";
const MAU_HEADER = "FFEFEFEF";

async function taiXuong(workbook, tenFile) {
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = tenFile;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}

function chuoi(v) {
  if (v == null || v === "") return "";
  return String(v);
}

/**
 * @param {object} p
 * @param {Array} p.danhSach — danh sách HTX (đã chuẩn hoá từ hopTacXaApi)
 */
export async function xuatExcelHopTacXa({ danhSach = [] }) {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = TEN_CONG_TY;

  const cot = [
    { header: "Mã HTX", width: 20 },
    { header: "Tên hợp tác xã", width: 28 },
    { header: "Người đại diện", width: 20 },
    { header: "SĐT", width: 14 },
    { header: "Email", width: 24 },
    { header: "Địa chỉ", width: 28 },
    { header: "Xã", width: 16 },
    { header: "Tỉnh", width: 14 },
    { header: "Mã tỉnh", width: 10 },
    { header: "Mã xã", width: 10 },
    { header: "Ngày tạo", width: 20 },
  ];

  const sheet = workbook.addWorksheet("Hợp tác xã");
  sheet.mergeCells(1, 1, 1, cot.length);
  sheet.getCell(1, 1).value = TEN_CONG_TY;
  sheet.getCell(1, 1).font = { bold: true };

  sheet.mergeCells(2, 1, 2, cot.length);
  sheet.getCell(2, 1).value = "Danh sách hợp tác xã";
  sheet.getCell(2, 1).font = { bold: true, size: 13 };

  sheet.mergeCells(3, 1, 3, cot.length);
  sheet.getCell(3, 1).value = `Xuất ngày ${new Date().toLocaleString("vi-VN")}`;
  sheet.getCell(3, 1).font = { italic: true, size: 10 };

  const hangHeader = sheet.getRow(5);
  cot.forEach((c, i) => {
    const cell = hangHeader.getCell(i + 1);
    cell.value = c.header;
    cell.font = { bold: true };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: MAU_HEADER } };
    cell.alignment = { horizontal: "center", wrapText: true };
    sheet.getColumn(i + 1).width = c.width;
  });

  danhSach.forEach((htx) => {
    sheet.addRow([
      chuoi(htx.maHopTacXa),
      chuoi(htx.tenHopTacXa),
      chuoi(htx.nguoiDaiDien),
      chuoi(htx.sdt),
      chuoi(htx.email),
      chuoi(htx.diaChi),
      chuoi(htx.xa),
      chuoi(htx.tinh),
      chuoi(htx.tinhMa),
      chuoi(htx.xaMa),
      chuoi(htx.createdAt),
    ]);
  });

  const stamp = new Date().toISOString().slice(0, 10);
  await taiXuong(workbook, `hop-tac-xa-${stamp}.xlsx`);
}
